import React, { useState, useRef, useEffect } from "react";
import { Box, Typography, Checkbox } from "@mui/material";

const Dropdown = ({
  defaultValue,
  onSelectedValue,
  optionList,
  className,
  showCheckbox = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(defaultValue);
  const dropdownRef = useRef(null);

  const handleToggle = () => {
    setIsOpen((prev) => !prev);
  };

  const handleSelect = (value) => {
    setSelected(value);
    onSelectedValue(value);
    // console.log("value", value);
    setIsOpen(false);
  };

  const handleCheckboxChange = (option) => {
    const newValue = selected === option ? null : option;
    setSelected(newValue);
    onSelectedValue(newValue);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <Box className="relative text-black" ref={dropdownRef}>
      <div
        onClick={handleToggle}
        className={`cursor-pointer border border-transparent rounded-md p-1
                    bg-[#F1F6FA] flex justify-between items-center gap-2
                    ${isOpen ? "border-red-500" : ""}
                    focus:outline-1 focus:outline-black focus:border-black
					focus:ring-1 focus:ring-black ${className}`}
        tabIndex={0} // Make the div focusable
      >
        <Typography className="text-xs font-medium bg-[#F1F6FA]">
          {selected?.replace("_", " ") || defaultValue}
        </Typography>
        <svg
          className={`w-4 h-4 transition-transform duration-200 ${
            isOpen ? "rotate-180" : ""
          }`}
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </div>
      {isOpen && (
        <div className="absolute z-10 mt-1 bg-white rounded-md border border-slate-300 shadow-lg min-w-max max-h-30 overflow-y-auto w-full">
          {optionList.map((option) => (
            <div
              key={option}
              className="flex justify-between items-center cursor-pointer px-3 py-1 text-xs hover:bg-slate-200 gap-1"
            >
              <Typography sx={{
                fontSize: "14px",
              }} onClick={() => handleSelect(option)} className="">
                {option?.replace("_", " ")}
              </Typography>
              {showCheckbox && (
                <input
                  // size="small"
                  type="checkbox"
                  checked={selected === option}
                  onChange={() => handleCheckboxChange(option)}
                  // color="primary"
                />
              )}
            </div>
          ))}
        </div>
      )}
    </Box>
  );
};

export default Dropdown;
